// Skills Database for ATS Scanner
export const skillsDatabase = [
  // Programming Languages
  'JavaScript', 'Python', 'Java', 'C++', 'C#', 'Ruby', 'PHP',
  'Swift', 'Kotlin', 'Go', 'Rust', 'TypeScript', 'Scala', 'R',
  'Perl', 'Objective-C', 'Dart', 'MATLAB', 'Shell', 'Bash',
  
  // Web Development - Frontend
  'HTML', 'HTML5', 'CSS', 'CSS3', 'React', 'React.js', 'Vue', 'Vue.js',
  'Angular', 'AngularJS', 'Svelte', 'Next.js', 'Nuxt.js', 'Gatsby',
  'jQuery', 'Bootstrap', 'Tailwind', 'Tailwind CSS', 'Material-UI',
  'Sass', 'SCSS', 'Less', 'Webpack', 'Babel', 'Vite', 'Parcel',
  
  // Web Development - Backend
  'Node.js', 'Express', 'Express.js', 'Django', 'Flask', 'FastAPI',
  'Spring', 'Spring Boot', 'ASP.NET', '.NET', 'Laravel', 'Rails',
  'Ruby on Rails', 'NestJS', 'Koa', 'Hapi', 'Strapi',
  
  // Databases
  'SQL', 'MySQL', 'PostgreSQL', 'MongoDB', 'Redis', 'Oracle',
  'SQL Server', 'Microsoft SQL Server', 'DynamoDB', 'Cassandra',
  'SQLite', 'Firebase', 'Firestore', 'CouchDB', 'MariaDB',
  'Elasticsearch', 'Neo4j', 'GraphQL', 'Prisma',
  
  // Cloud Platforms
  'AWS', 'Amazon Web Services', 'Azure', 'Microsoft Azure', 
  'Google Cloud', 'GCP', 'Google Cloud Platform', 'Heroku',
  'DigitalOcean', 'Linode', 'Vercel', 'Netlify', 'CloudFlare',
  
  // Cloud Services
  'EC2', 'S3', 'Lambda', 'CloudFormation', 'RDS', 'DynamoDB',
  'API Gateway', 'CloudWatch', 'IAM', 'VPC', 'Route53',
  'Azure Functions', 'Azure DevOps', 'Google Cloud Functions',
  
  // DevOps & CI/CD
  'Docker', 'Kubernetes', 'K8s', 'Jenkins', 'CI/CD', 'Git',
  'GitHub', 'GitLab', 'Bitbucket', 'Terraform', 'Ansible',
  'Puppet', 'Chef', 'CircleCI', 'Travis CI', 'GitHub Actions',
  'GitLab CI', 'ArgoCD', 'Helm', 'Istio', 'Prometheus', 'Grafana',
  
  // Data Science & Machine Learning
  'Machine Learning', 'Deep Learning', 'TensorFlow', 'PyTorch',
  'Keras', 'Scikit-learn', 'Pandas', 'NumPy', 'SciPy', 'Jupyter',
  'NLP', 'Natural Language Processing', 'Computer Vision', 'CNN',
  'RNN', 'LSTM', 'Transformer', 'BERT', 'GPT', 'OpenAI',
  'Data Mining', 'Statistical Analysis', 'Predictive Modeling',
  
  // Mobile Development
  'iOS', 'Android', 'React Native', 'Flutter', 'Xamarin',
  'Ionic', 'Cordova', 'SwiftUI', 'UIKit', 'Jetpack Compose',
  
  // Testing & Quality Assurance
  'Jest', 'Mocha', 'Chai', 'Jasmine', 'Cypress', 'Selenium',
  'WebDriver', 'Puppeteer', 'Playwright', 'JUnit', 'TestNG',
  'PyTest', 'Unit Testing', 'Integration Testing', 'E2E Testing',
  'TDD', 'Test-Driven Development', 'BDD', 'Cucumber',
  
  // Methodologies & Practices
  'Agile', 'Scrum', 'Kanban', 'Lean', 'DevOps', 'Waterfall',
  'SAFe', 'XP', 'Extreme Programming', 'Continuous Integration',
  'Continuous Deployment', 'Microservices', 'SOA', 'REST',
  'RESTful', 'SOAP', 'MVC', 'MVVM', 'Clean Code', 'SOLID',
  
  // Design & UX
  'UI/UX', 'User Experience', 'User Interface', 'Figma', 'Sketch',
  'Adobe XD', 'InVision', 'Photoshop', 'Illustrator', 'After Effects',
  'Wireframing', 'Prototyping', 'User Research', 'Usability Testing',
  'Design Systems', 'Responsive Design', 'Mobile-First Design',
  
  // Project Management
  'Jira', 'Confluence', 'Trello', 'Asana', 'Monday.com',
  'Microsoft Project', 'Basecamp', 'ClickUp', 'Notion',
  'Project Planning', 'Resource Management', 'Risk Management',
  'Stakeholder Management', 'Budget Management',
  
  // Business & Analytics
  'Excel', 'Microsoft Excel', 'PowerPoint', 'Word', 'Outlook',
  'Tableau', 'Power BI', 'Looker', 'Google Analytics', 'Mixpanel',
  'Amplitude', 'Data Visualization', 'Business Intelligence',
  'KPI', 'Metrics', 'A/B Testing', 'SQL Analysis',
  
  // CRM & Business Tools
  'Salesforce', 'HubSpot', 'Zendesk', 'ServiceNow', 'SAP',
  'Oracle ERP', 'Microsoft Dynamics', 'Zoho', 'Pipedrive',
  
  // Security
  'Cybersecurity', 'Information Security', 'Penetration Testing',
  'Ethical Hacking', 'OWASP', 'SSL/TLS', 'Encryption', 'OAuth',
  'JWT', 'Authentication', 'Authorization', 'Security Audits',
  'Compliance', 'GDPR', 'HIPAA', 'PCI-DSS', 'ISO 27001',
  
  // Networking
  'TCP/IP', 'HTTP', 'HTTPS', 'DNS', 'VPN', 'Firewall',
  'Load Balancing', 'CDN', 'Network Security', 'Routing',
  'Switching', 'VLAN', 'BGP', 'OSPF',
  
  // Version Control
  'Git', 'GitHub', 'GitLab', 'Bitbucket', 'SVN', 'Mercurial',
  'Version Control', 'Source Control', 'Code Review',
  
  // Soft Skills
  'Leadership', 'Team Leadership', 'Communication', 'Teamwork',
  'Problem Solving', 'Critical Thinking', 'Analytical Skills',
  'Time Management', 'Adaptability', 'Flexibility', 'Creativity',
  'Innovation', 'Decision Making', 'Conflict Resolution',
  'Interpersonal Skills', 'Collaboration', 'Mentoring',
  'Public Speaking', 'Presentation Skills', 'Writing',
  'Technical Writing', 'Documentation', 'Customer Service',
  'Client Relations', 'Negotiation', 'Strategic Thinking',
  'Planning', 'Organization', 'Multitasking', 'Attention to Detail',
  
  // Marketing & Sales
  'Digital Marketing', 'SEO', 'Search Engine Optimization',
  'SEM', 'Search Engine Marketing', 'Social Media Marketing',
  'Content Marketing', 'Email Marketing', 'PPC', 'Google Ads',
  'Facebook Ads', 'Instagram Marketing', 'LinkedIn Marketing',
  'Marketing Automation', 'Campaign Management', 'Brand Management',
  'Market Research', 'Competitive Analysis', 'Sales',
  'Business Development', 'Lead Generation', 'CRM',
  
  // Finance & Accounting
  'Financial Analysis', 'Budgeting', 'Forecasting', 'Accounting',
  'QuickBooks', 'SAP Finance', 'Financial Modeling', 'Audit',
  'Tax', 'Payroll', 'Accounts Payable', 'Accounts Receivable',
  
  // HR & Recruitment
  'Recruiting', 'Talent Acquisition', 'HR Management', 'HRIS',
  'Employee Relations', 'Performance Management', 'Training',
  'Learning and Development', 'Compensation', 'Benefits',
  
  // Industry-Specific
  'Healthcare', 'Medical', 'Clinical', 'Pharmacy', 'Nursing',
  'Legal', 'Law', 'Litigation', 'Contract Law', 'Real Estate',
  'Construction', 'Manufacturing', 'Supply Chain', 'Logistics',
  'Retail', 'E-commerce', 'Education', 'Teaching', 'Curriculum',
];

export const actionVerbs = [
  'achieved', 'accomplished', 'administered', 'advanced', 'analyzed',
  'assessed', 'assisted', 'attained', 'automated', 'awarded',
  'built', 'calculated', 'collaborated', 'compiled', 'completed',
  'composed', 'computed', 'conducted', 'configured', 'consolidated',
  'constructed', 'consulted', 'coordinated', 'created', 'customized',
  'debugged', 'decreased', 'defined', 'delegated', 'delivered',
  'demonstrated', 'deployed', 'designed', 'developed', 'devised',
  'diagnosed', 'directed', 'discovered', 'documented', 'doubled',
  'drove', 'earned', 'edited', 'educated', 'eliminated',
  'enabled', 'encouraged', 'engineered', 'enhanced', 'ensured',
  'established', 'evaluated', 'exceeded', 'executed', 'expanded',
  'expedited', 'facilitated', 'finalized', 'forecasted', 'formulated',
  'founded', 'generated', 'grew', 'guided', 'handled',
  'headed', 'identified', 'illustrated', 'implemented', 'improved',
  'increased', 'influenced', 'initiated', 'innovated', 'inspected',
  'installed', 'instituted', 'instructed', 'integrated', 'introduced',
  'invented', 'investigated', 'launched', 'led', 'leveraged',
  'maintained', 'managed', 'maximized', 'mentored', 'migrated',
  'minimized', 'modernized', 'modified', 'monitored', 'motivated',
  'negotiated', 'obtained', 'operated', 'optimized', 'orchestrated',
  'organized', 'originated', 'overhauled', 'oversaw', 'participated',
  'performed', 'pioneered', 'planned', 'prepared', 'presented',
  'prioritized', 'processed', 'produced', 'programmed', 'projected',
  'promoted', 'proposed', 'provided', 'published', 'purchased',
  'quadrupled', 'quantified', 'raised', 'reallocated', 'rebuilt',
  'received', 'recommended', 'reconciled', 'recorded', 'recruited',
  'redesigned', 'reduced', 're-engineered', 'refined', 'reinforced',
  'reorganized', 'replaced', 'reported', 'repositioned', 'represented',
  'researched', 'resolved', 'restructured', 'revamped', 'reviewed',
  'revised', 'revitalized', 'saved', 'scaled', 'scheduled',
  'secured', 'selected', 'simplified', 'solved', 'spearheaded',
  'standardized', 'streamlined', 'strengthened', 'structured', 'succeeded',
  'supervised', 'supported', 'surpassed', 'synthesized', 'systematized',
  'targeted', 'taught', 'tested', 'trained', 'transformed',
  'translated', 'tripled', 'troubleshot', 'unified', 'updated',
  'upgraded', 'utilized', 'validated', 'verified', 'won',
];

export const industryKeywords = {
  software: [
    'software development', 'full stack', 'backend', 'frontend',
    'API', 'database', 'architecture', 'scalability', 'performance',
    'code review', 'debugging', 'testing', 'deployment', 'cloud',
    'agile', 'scrum', 'DevOps', 'microservices', 'mobile',
  ],
  dataScience: [
    'data analysis', 'statistical modeling', 'predictive analytics',
    'data visualization', 'big data', 'ETL', 'data mining',
    'business intelligence', 'reporting', 'machine learning',
    'deep learning', 'neural networks', 'data pipeline',
  ],
  marketing: [
    'digital marketing', 'SEO', 'SEM', 'social media', 'content strategy',
    'campaign management', 'analytics', 'conversion optimization',
    'brand management', 'market research', 'email marketing',
    'paid advertising', 'growth hacking', 'influencer marketing',
  ],
  design: [
    'user experience', 'user interface', 'wireframing', 'prototyping',
    'design systems', 'visual design', 'interaction design',
    'usability testing', 'user research', 'design thinking',
  ],
  projectManagement: [
    'project planning', 'stakeholder management', 'risk management',
    'resource allocation', 'budget management', 'timeline management',
    'agile methodologies', 'team coordination', 'deliverables',
  ],
  sales: [
    'lead generation', 'prospecting', 'closing', 'negotiation',
    'CRM', 'pipeline management', 'sales forecasting', 'quotas',
    'client relationships', 'business development', 'B2B', 'B2C',
  ],
};

export default skillsDatabase;
